import { API_ENDPOINTS } from "../config/api/apiCall";
import { callApi } from "../utils/apiClient";

export const loadDepartment = async () => {
    try {
        const payload = {

            p_companyid: localStorage.getItem('companyid') || 0,
            p_plantid: 1,
        };

        return await callApi(API_ENDPOINTS.DEPARTMENT_GET, 'POST', { 'Content-Type': 'application/json' }, payload);
    } catch (error) {
        console.error("Error saving shift roster:", error);
        throw error;
    }
};